import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=7dbcf522&scoped=true"
import script from "./CouponList.vue?vue&type=script&lang=ts"
export * from "./CouponList.vue?vue&type=script&lang=ts"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=7dbcf522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbcf522",
  null
  
)

export default component.exports